import loginImage from "../../assets/img/animation.gif";

function Splash() {
  return (
    <div className="fixed top-0 h-full w-full right-0 flex justify-center items-center bg-[#f9fafb] z-50">
      <img src={loginImage} className="w-[340px]" alt="" />
    </div>
  );
}

export default Splash;
